import React, { FC } from 'react';

import { useSmokingWarningText } from '@/scenarios/legacy-player/components/PlayerSkin/parts/AgeRestriction/useSmokingWarningText';

import { useEpisodeOtt } from '../../hooks/use-episode-ott';
import { getVideoSize } from '../../../movie-player/utils/get-video-size';
import { AgeRestrictionContainer } from '../../../feature-player/ui/skin/age-restriction/container';
import { useEpisodeAgeRestriction } from '../../hooks/use-episode-age-restriction';
import { useEpisodeCurrentStream } from '../../hooks/use-episode-current-stream';

interface EpisodeAgeRestrictionProps {
    contentId: string;
}

export const EpisodeAgeRestriction: FC<EpisodeAgeRestrictionProps> = ({ contentId }) => {
    const ageRestriction = useEpisodeAgeRestriction(contentId);
    const currentStream = useEpisodeCurrentStream(contentId);

    const ott = useEpisodeOtt(contentId);
    const hasSmokingScenes = ott?.hasSmokingScenes ?? undefined;

    const smokingWarningText = useSmokingWarningText('episode');

    const { videoHeight, videoWidth } = getVideoSize(currentStream);

    return (
        <AgeRestrictionContainer
            age={ageRestriction}
            videoHeight={videoHeight}
            videoWidth={videoWidth}
            smokingWarningText={hasSmokingScenes ? smokingWarningText : undefined}
        />
    );
};
